import { connect } from 'react-redux';
import View from './YearlySalaryView';
import {
  data2,
  iterator,
  isGoingForwardSelector,
  currentClientIdOrDefaultSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../IncomeWorkflowConstants';
import { fetchData, updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import {
  incomes as incomesSelector,
  yearlySalary,
  partnerYearlySalary,
  earnerPartner,
  earner,
} from '../IncomeWorkflowSelector';
import * as PersonalInfoConstants from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
  hasPartner: data2(state, ownProps)(`${PersonalInfoConstants.BACKEND_KEY}.HasPartner`),
  yearlySalary: yearlySalary(state, ownProps),
  earner: earner(state, ownProps),
  partnerYearlySalary: partnerYearlySalary(state, ownProps),
  earnerPartner: earnerPartner(state, ownProps),
  incomes: incomesSelector(state, ownProps),
  iterator: iterator(state, ownProps),
  isGoingForward: isGoingForwardSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  incomeChanged: (incomes, index, clientId, store) => event => {
    store(
      {
        [BACKEND_KEY]: [
          ...incomes.slice(0, index),
          {
            ...incomes[index],
            Amount: event.target.value,
          },
          ...incomes.slice(index + 1),
        ],
      },
      clientId,
    );
  },
  fetchData: (workflowId, clientId) => {
    dispatch(fetchData(workflowId, clientId, [BACKEND_KEY]));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
